import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DayOfWeek, RecipientSpotlightCardConfig } from './types';

dayjs.extend(utc);
dayjs.extend(timezone);

export const selectTodaysSpotlightCard = (
  cards: RecipientSpotlightCardConfig[] | undefined,
  today: DayOfWeek = dayjs().tz('America/New_York').format('dddd').toLowerCase() as DayOfWeek
): RecipientSpotlightCardConfig | undefined => {
  if (!cards?.length) {
    return undefined;
  }

  const validCards = cards.filter(card => card?.recipient_id && card?.cta_link);

  return (
    validCards.find(card => card?.visible_days?.includes(today)) ||
    validCards.find(card => card?.visible_days?.includes('default')) ||
    validCards.find(card => !card?.visible_days?.length)
  );
};
